import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    homeList,
} from "../../../../../../services/adapters/kepegawaian/homeService"
import { 
    koreksiKehadiranDetail,
    koreksiKehadiranApproval,
    masterRegion,
    list_pegawai
} from '../../../../../../services/adapters/kepegawaian/koreksiKehadiranService'


class IndexRepository {

    fetchEmployeeList = async (query) => {
        return await apiRequest("get", list_pegawai, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", koreksiKehadiranDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchApproval = async (query, cancelToken) => {
        return await apiRequest("post", koreksiKehadiranApproval, {
            body: query
        }, true)
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }




}

export default IndexRepository